import React from 'react';

import Latex from 'react-latex';

const MathInput = props => {
	// eslint-disable-next-line no-unused-vars
	const { mathItem, showBlock } = props;

	return <Latex>{mathItem}</Latex>;
};

export default MathInput;
